import { useEffect, useRef } from 'react';
import { mergeRefs } from '@grupoboticario/flora-react-utils';
export var useFloraCheckbox = _ref => {
  var {
    forwardedRef,
    indeterminate
  } = _ref;
  var internalRef = useRef(null);
  useEffect(() => {
    if (internalRef != null && internalRef.current) {
      internalRef.current.indeterminate = !!indeterminate;
    }
  }, [indeterminate]);
  return {
    ref: mergeRefs(forwardedRef, internalRef)
  };
};
//# sourceMappingURL=useFloraCheckbox.js.map